<template>
  <div>
    <div is="style" scoped="scoped">
      {{ outputStyles() }}
      {{ previewOriginalStyle }}
    </div>
    <table class="preview">
      <tbody>
        <tr>
          <td>
            <preview-section
              v-for="section in $store.state.sections"
              :ref="'preview-section' + section.id"
              :section="section"
              :key="section.id"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import PreviewSection from '@/components/Content/Preview/PreviewSection'

export default {
  name: 'Preview',
  components: {
    PreviewSection,
  },
  data () {
    return {
      previewOriginalStyle: '',
      isLoading: false,
    }
  },
  created () {
    this.makePreviewStyle()
  },
  computed: {
    originalStyle () {
      return this.$store.state.appliedOriginalStyle
    },
  },
  methods: {
    // storeのcss設定からcssファイルを作成する
    outputStyles () {
      // { id: 1, selector: 'h1', prop: 'font-size', value: '40px' } の形
      // 表示に不要な項目を取り除く
      const filteredStyles = this.$store.state.styles.filter(style => style.prop !== 'font-family-name')
      return filteredStyles.map(style => `.preview ${JSON.parse(JSON.stringify(style.selector))} { ${JSON.parse(JSON.stringify(style.prop))}: ${JSON.parse(JSON.stringify(style.value))} }`).join('\n')
    },
    makePreviewStyle () {
      if (this.originalStyle === null) {
        // 別のメーリングから移動した場合のために '' を入れる
        this.previewOriginalStyle = ''
        return
      }
      const formData = new FormData()
      formData.append('originalStyle', this.originalStyle)
      this.$emit('showLoading', true)
      this.$http({
        url: '/content/make_preview_style',
        type: 'POST',
        params: formData
      }).then(json => {
        if (json && json.status === 200) {
          this.previewOriginalStyle = json.data
        }
        // セクションの高さを再計算する
        this.$store.state.sections.forEach(section => {
          this.$refs['preview-section' + section.id][0].changeWindowHeight()
        })
        this.$emit('showLoading', false)
      })
    },
  },
  watch: {
    originalStyle () {
      this.makePreviewStyle()
    }
  }
}
</script>

<style scoped>
.preview {
  margin-bottom: 40px;
  width: 100%;
  position: relative;
}
</style>
